import { useTranslation } from "react-i18next";
import { GrLocation } from "react-icons/gr";
import {
  HiOutlineHeart,
  HiOutlineStar,
  HiOutlineCash,
  HiOutlineUserGroup,
} from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

interface IProps {
  id: number;
  schoolName: string;
  schoolDescription: string;
  imgUrl: string;
  studentsNumber: string;
  country: string;
  city: string;
  district: string;
  startingPrice: string;
  rating: number;
}
function SchoolCardResultsComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
      <div
        onClick={() =>
          navigate(appRoutesObj.getSchoolDetailsPageUrl(props.id.toString()))
        }
        className={`flex flex-row justify-start items-start w-[754px] laptop:w-[680px] tablet:w-[550px] ${
          i18n.language === "ar" ? "gap-[110px]" : "gap-[90px]"
        }  rounded-2xl shadow-[rgba(0,_0,_0,_0.05)0px_0px_20px_0px] bg-white py-[25px] px-3 mobile:hidden tablet:hidden cursor-pointer`}
      >
        <div className="flex flex-row gap-[13px]">
          <HiOutlineHeart
            className={`absolute ${
              i18n.language === "ar" ? "mr-1" : "ml-1"
            } mt-1 text-2xl text-zinc-50 cursor-pointer`}
          />
          <img
            src={props.imgUrl}
            className="w-[176px] h-[170px] laptop:w-[150px] tablet:w-[140px] rounded-lg"
            alt=""
          />
          <div className="flex flex-col gap-2.5">
            <p className="font-arBold text-xl">{props.schoolName}</p>
            <p className="font-arRegular text-zinc700 w-[299.5px]">
              {props.schoolDescription}
            </p>
            <div className="flex items-center gap-1">
              <HiOutlineUserGroup size={14} className="text-zinc700 mb-1" />
              <p className="text-sm text-zinc700 font-arRegular">
                {props.studentsNumber}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <GrLocation size={14} className="text-zinc700" />
              <p className="text-sm text-zinc700 font-arRegular">
                {props.district} ، {props.city} ، {props.country}
              </p>
            </div>
          </div>
        </div>
        <div
          className={`flex flex-col items-end ${
            i18n.language === "ar" ? "w-[128px]" : "w-[150px]"
          } gap-[105px]`}
        >
          <div className=" flex flex-row gap-2 justify-center items-center w-20 h-8 rounded-lg bg-tart500 backdrop-blur-md">
            <HiOutlineStar className="text-2xl text-zinc-50 cursor-pointer" />
            <p className="text-sm text-zinc-50 font-arMedium mt-1.5">
              {props.rating}
            </p>
          </div>
          <div className="flex">
            <HiOutlineCash className="text-green600 w-[22px] h-5" />
            <p className="text-base font-arRegular text-green600">
              {t("resultSchoolCard.component.startfrom")} {props.startingPrice}
            </p>
          </div>
        </div>
      </div>
      {/* mobile & tablet */}
      <div
        onClick={() =>
          navigate(appRoutesObj.getSchoolDetailsPageUrl(props.id.toString()))
        }
        className="flex mobile:w-[359px] tablet:w-[420px] laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden px-3 pb-4 cursor-pointer"
      >
        <div className="flex flex-row gap-[13px]">
          <HiOutlineHeart
            className={`absolute ${
              i18n.language === "ar" ? "mr-1" : "ml-1"
            } mt-1 text-2xl text-zinc-50 cursor-pointer`}
          />
          <img
            src={props.imgUrl}
            className="mobile:w-[127px] tablet:w-[200px] h-[185px] rounded-lg"
            alt=""
          />
          <div className="flex flex-col gap-3">
            <p className="font-arBold text-base">{props.schoolName}</p>
            <div
              className={`flex flex-row gap-1 justify-center items-center w-[58px] h-6 rounded bg-tart500 backdrop-blur-md ${
                i18n.language === "ar" ? "pl-4 pr-2" : "pr-4 pl-2"
              } `}
            >
              <HiOutlineStar className="w-[16px] h-[16px] text-zinc-50 cursor-pointer" />
              <p className="text-xs text-zinc-50 font-arMedium mt-1">
                {props.rating}
              </p>
            </div>
            <p className="font-arRegular text-zinc700 w-[207px] tablet:w-[280px] text-sm line-clamp-3">
              {props.schoolDescription}
            </p>
            <div className="flex items-center gap-1">
              <GrLocation size={14} className="text-zinc700" />
              <p className="text-sm text-zinc700 font-arRegular">
                {props.district} ، {props.city} ، {props.country}
              </p>
            </div>
            <div className="flex">
              <HiOutlineCash className="text-green600 w-[22px] h-5" />
              <p className="text-base font-arRegular text-green600">
                {t("resultSchoolCard.component.startfrom")}{" "}
                {props.startingPrice}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr className="mx-3 tablet:hidden laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden"></hr>
    </div>
  );
}

export default SchoolCardResultsComponent;
